// extracted by mini-css-extract-plugin
export default {"cta":"kvI9cc"};